// Nav Bar Button Management Functions
// Get the libraries from Vue
import {
    ref
} from "vue"

// Get the Styling for the button
import {
    buttonColor
} from "@/../../library/constants/colors.js"
import {
    buttonStyle
} from "@/../../library/compFunctions/useStyles.js"

export function useNavButtons() {

    // Nav bar configuration
    let config = ref({
        "buttonList": [],
        counter: 0,
    })

    // Add button
    const add = (button) => {
        let buttonDef = buttonStyle(button, buttonColor(button))
        config.value["buttonList"].push(buttonDef)
        config.value.counter++
    }

    // Remove a button
    const remove = (button) => {
        let index = config.value["buttonList"].findIndex(x => x.name === button)
        if (index !== -1) {
            config.value["buttonList"] = config.value["buttonList"].splice(index, 1)
            config.value.counter--
        }
    }

    // Enable a button
    const enable = (button) => {
        console.log(`******** Enable a button = ${button}`)
        let index = config.value["buttonList"].findIndex(x => x.name === button)
        if (index !== -1){
            config.value["buttonList"][index]["config"]["disable"] = false
            config.value.counter++
        }
    }

    // Disable a button
    const disable = (button) => {
        console.log(`********* Disabling a button`)
        let index = config.value["buttonList"].findIndex(x => x.name === button)
        if(index !== -1){
            config.value["buttonList"][index]["config"]["disable"] = true
            config.value.counter++
        }
    }

    // Remove all Buttons
    const removeAll = () => {
        config.value["buttonList"].length = 0
        config.value.counter = 0
    }

    // Expose variables and methods
    return {
        config,
        add,
        remove,
        enable,
        removeAll,
        disable
    }
}